import { css } from "@emotion/react";
import { LeftArrowSvg, RightArrowSvg } from "../../../../assets";

import { DotNavigation } from "./DotNavigation";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";

export const NavigationBar: React.FC<{
  onPrevious: () => void;
  onNext: () => void;
  shouldPassThroughWalls: () => boolean;
  visibleIdx: number;
  setVisibleIdx: (idx: number) => void;
  items: Array<unknown>;
  theme: "dark-background" | "light-background";
}> = ({ onPrevious, onNext, shouldPassThroughWalls, visibleIdx, setVisibleIdx, items, theme }) => {
  return (
    <div
      className={theme}
      css={css`
        display: flex;

        justify-content: center;
        margin-top: 20px;
      `}
    >
      <button onClick={() => onPrevious()} disabled={!shouldPassThroughWalls() && visibleIdx === 0} css={iconStyles}>
        <LeftArrowSvg />
      </button>

      <DotNavigation items={items} visibleIdx={visibleIdx} setVisibleIdx={setVisibleIdx} />

      <button
        onClick={() => onNext()}
        disabled={!shouldPassThroughWalls() && visibleIdx === items.length - 1}
        css={iconStyles}
      >
        <RightArrowSvg />
      </button>
    </div>
  );
};

const iconStyles = css`
  svg {
    width: 32px;
  }

  &.light-background {
    color: ${CSS_COLORS.Green};
    &[disabled] {
      color: ${CSS_COLORS.Grey2};
    }
  }

  &.dark-background {
    color: ${CSS_COLORS.White};
    &[disabled] {
      color: ${CSS_COLORS.Grey2};
    }
  }

  &[disabled] {
    cursor: not-allowed;
  }
`;
